<template>
  <div :class="event_wrapper_class != undefined && event_wrapper_class != '' ? event_wrapper_class : ''">
    <div class="case-kalendar-event" @click="openPopup(single_event)">
      <div class="event-type-wrapper">
        <div :class="'vrsta-eventa event-' + single_event.event_type.class_colour">
          {{ single_event.event_type.name }}
        </div>
        <div v-if="single_event.personal_event != undefined" :class="'vrsta-eventa event-green'">
          {{ $t("components.calendar.event_card.tags.pers") }}
        </div>
        <div v-if="single_event.case_id != null" :class="'vrsta-eventa event-grey'">
          {{ $t("components.calendar.event_card.tags.case") }}
        </div>
        <div v-if="single_event.project_id != null" :class="'vrsta-eventa event-pink'">
          {{ $t("components.calendar.event_card.tags.proj") }}
        </div>
        <div v-if="single_event.status_id == 100" :class="'vrsta-eventa event-green'">
          Izvršeno
        </div>
      </div>
      <div class="kalendar-event-details">
        <div class="edit-kalendar-event">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="5" viewBox="0 0 21 5"> <g> <g> <path fill="#a5a5a5" d="M5 2.5C5 3.882 3.882 5 2.5 5A2.498 2.498 0 0 1 0 2.5C0 1.117 1.116 0 2.5 0 3.882 0 5 1.117 5 2.5z" /> </g> <g> <path fill="#a5a5a5" d="M13 2.5C13 3.882 11.882 5 10.5 5A2.498 2.498 0 0 1 8 2.5C8 1.117 9.116 0 10.5 0 11.882 0 13 1.117 13 2.5z" /> </g> <g> <path fill="#a5a5a5" d="M21 2.5C21 3.882 19.882 5 18.5 5A2.498 2.498 0 0 1 16 2.5C16 1.117 17.116 0 18.5 0 19.881 0 21 1.117 21 2.5z" /> </g> </g> </svg>
        </div>
        <div class="kalendar-event-title">
          {{ single_event.title }}
        </div>
        <div v-if="single_event.predmet != undefined">
          <div @click.stop="goToCase(single_event.case_id)" v-if="can_i_see()" class="kalendar-event-case-name underline-item">{{  single_event.predmet.ime_predmeta.length > 50 ? single_event.predmet.ime_predmeta.slice(0,50)+'...' :  single_event.predmet.ime_predmeta }}</div>
          <div v-else class="kalendar-event-case-name">
            {{ single_event.predmet.ime_predmeta.length > 50 ? single_event.predmet.ime_predmeta.slice(0,50)+'...' :  single_event.predmet.ime_predmeta }}
          </div>
        </div>
        <div v-else-if="single_event.project != undefined">
          <div @click.stop="goToProject(single_event.project_id)" v-if="can_i_see()" class="kalendar-event-case-name underline-item">{{  single_event.project.name .length > 50 ? single_event.project.name.slice(0,50)+'...' :  single_event.project.name  }}</div>
          <div v-else class="kalendar-event-case-name">
            {{ single_event.project.name .length > 50 ? single_event.project.name.slice(0,50)+'...' :  single_event.project.name }}
          </div>
        </div>
        <div class="vrijeme-lokacija-event">
          <div class="datum-event">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3595 2.42254L14.3604 3.07846C16.7707 3.26737 18.3629 4.90979 18.3655 7.42853L18.375 14.8011C18.3784 17.5472 16.6532 19.2369 13.8878 19.2412L7.1329 19.25C4.38479 19.2535 2.63796 17.5236 2.63451 14.7696L2.62501 7.48363C2.62155 4.94828 4.15759 3.31022 6.5679 3.08896L6.56704 2.43303C6.56617 2.04823 6.85126 1.75875 7.23138 1.75875C7.61151 1.75787 7.8966 2.04648 7.89746 2.43129L7.89832 3.04348L13.03 3.03648L13.0291 2.42429C13.0282 2.03948 13.3133 1.75088 13.6934 1.75C14.0649 1.74913 14.3587 2.03773 14.3595 2.42254ZM3.95629 7.75387L17.0359 7.73638V7.43028C16.9988 5.54997 16.0554 4.56347 14.3621 4.41654L14.363 5.08995C14.363 5.46602 14.0701 5.76424 13.6986 5.76424C13.3185 5.76512 13.0326 5.46776 13.0326 5.0917L13.0317 4.38331L7.90005 4.3903L7.90091 5.09782C7.90091 5.47476 7.61669 5.77211 7.23657 5.77211C6.85645 5.77299 6.57049 5.47651 6.57049 5.09957L6.56963 4.42616C4.885 4.59495 3.95284 5.58496 3.95543 7.48188L3.95629 7.75387ZM13.3349 11.7288V11.7384C13.3436 12.1407 13.6718 12.4459 14.0701 12.4371C14.4589 12.4275 14.769 12.0943 14.7604 11.692C14.7422 11.3072 14.4304 10.9932 14.0425 10.9941C13.6451 11.0029 13.3341 11.3265 13.3349 11.7288ZM14.0485 15.6555C13.6511 15.6468 13.3306 15.3153 13.3297 14.913C13.3211 14.5107 13.6399 14.1775 14.0373 14.1679H14.0459C14.452 14.1679 14.7811 14.4994 14.7811 14.9104C14.782 15.3215 14.4537 15.6547 14.0485 15.6555ZM9.7756 11.7427C9.79288 12.145 10.122 12.459 10.5194 12.4415C10.9082 12.4232 11.2183 12.0908 11.2011 11.6885C11.1916 11.295 10.8719 10.9889 10.4831 10.9897C10.0857 11.0072 9.77474 11.3404 9.7756 11.7427ZM10.5229 15.6162C10.1255 15.6337 9.7972 15.3197 9.77906 14.9174C9.77906 14.5151 10.0892 14.1828 10.4866 14.1644C10.8754 14.1635 11.1959 14.4696 11.2045 14.8623C11.2227 15.2655 10.9116 15.5978 10.5229 15.6162ZM6.21629 11.7734C6.23357 12.1757 6.56272 12.4905 6.96012 12.4721C7.34888 12.4546 7.65902 12.1214 7.64088 11.7191C7.63224 11.3256 7.31259 11.0195 6.92297 11.0204C6.52557 11.0379 6.21542 11.3711 6.21629 11.7734ZM6.96357 15.6206C6.56617 15.6389 6.23788 15.3241 6.21974 14.9218C6.21888 14.5195 6.52989 14.1863 6.92729 14.1688C7.31605 14.1679 7.63656 14.474 7.6452 14.8676C7.66334 15.2699 7.35319 15.6031 6.96357 15.6206Z" fill="#55556A" /> </svg>
            {{ getDate(single_event.start_date_time) }}
          </div>
          <div v-if="single_event.event_type.uid == 2 || single_event.event_type.uid == 3" class="vrijeme-event">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"> <g> <g> <path fill="#606076" d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z" /> </g> </g> </svg>
            <div>
              <div v-if="
                single_event.start_date_time != single_event.end_date_time
              ">
                {{ getSatiEvent(single_event.start_date_time) }} -
                {{ getSatiEvent(single_event.end_date_time) }}
              </div>
              <div v-else>{{ getSatiEvent(single_event.start_date_time) }}</div>
            </div>
          </div>
          <div v-if="single_event.location_address != null" class="lokacija-event">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20"> <g> <g> <path fill="#606076" d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z" /> </g> </g> </svg>
            <div :title="single_event.location_address" class="location-text ellipsis-overflow">{{ single_event.location_address }}</div>
          </div>
        </div>
        <div v-if="single_event.body != ''" class="event-opis-text">
          {{ single_event.body }}
        </div>
        <!-- <div
          v-if="
            single_event.location_name != '' &&
            single_event.location_name != null &&
            !single_event.is_online
          "
          class="event-opis-location"
        >
          {{ single_event.location_name }}
        </div> -->
        <div v-if="single_event.is_online" class="event-opis-location">
          <a target="_blank" class="underline-item" :href="single_event.meeting_url">
            {{ single_event.meeting_url != null && single_event.meeting_url.length > 40
                ? single_event.meeting_url.slice(0, 40) + "..."
                : single_event.meeting_url
            }}
          </a>
        </div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <!-- <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 0C3.13429 0 0 3.13429 0 7C0 10.8657 3.13429 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13429 10.8657 0 7 0ZM6.92 3.00857C8.09571 3.00857 9.05429 3.95286 9.05429 5.11143C9.05429 6.27 8.09714 7.21429 6.92 7.21429C5.74429 7.21429 4.78571 6.27 4.78571 5.11143C4.78714 3.95286 5.74429 3.00857 6.92 3.00857ZM10.4929 10.6143C10.4929 11.3786 9.24429 11.3786 7.79857 11.3786H6.2C4.69429 11.3786 3.50571 11.3786 3.50571 10.6143V10.4571C3.50571 8.99429 4.71429 7.80429 6.2 7.80429H7.8C9.28571 7.80429 10.4943 8.99429 10.4943 10.4571L10.4929 10.6143Z" fill="#535568"/>
                  </svg> -->
            <div class="event-participants">
              <div
                v-for="(partic, key) in single_event.event_lawyer_connector"
                :key="key"
                class="event-participant case-team-member-img"
                :style="get_avatar(partic.odvjetnik)"
                :title="`${partic.odvjetnik.ime} ${partic.odvjetnik.prezime}`">
                <div class="case-team-initials-circle" v-if="!get_avatar(partic.odvjetnik)">{{ partic.odvjetnik.ime.charAt(0) + partic.odvjetnik.prezime.charAt(0) }}</div>
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="case-team-initials-circle "
                    >
                    </div>
                  </template>
                  <p>
                    {{ partic.odvjetnik.ime }} {{ partic.odvjetnik.prezime }}
                  </p>
                </v-tooltip> -->
              </div>
              <div v-if="single_event.event_lawyer_connector.length == 1" class="event-participant-text">{{
                  single_event.event_lawyer_connector[
                    single_event.event_lawyer_connector.length - 1
                  ].odvjetnik.ime
              }}
                {{
                    single_event.event_lawyer_connector[
                      single_event.event_lawyer_connector.length - 1
                    ].odvjetnik.prezime
                }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import $ from "jquery"
import gsap from "gsap"
import { Sine } from "gsap"
import avatarService from "@/services/avatarService"
export default {
  props: ["single_event", 'event_wrapper_class', "tab_name", "project_event", {
    mapped_permission: {
      typeof: Array,
      default: []
    }
  }],
  data() {
    return {
      avatarStyles: {} // Map of odvjetnik uid -> avatar style
    }
  },
  watch: {
    single_event: {
      immediate: true,
      handler: function(newVal) {
        if (newVal && newVal.event_lawyer_connector) {
          this.loadAvatars();
        }
      }
    }
  },
  methods: {
    async loadAvatars() {
      if (!this.single_event || !this.single_event.event_lawyer_connector) return;

      var self = this;
      var promises = this.single_event.event_lawyer_connector.map(function(partic) {
        return avatarService.getAvatarStyle(partic.odvjetnik).then(function(style) {
          self.$set(self.avatarStyles, partic.odvjetnik.uid, style);
        });
      });

      await Promise.all(promises);
    },
    can_i_see() {
      return (this.single_event.event_lawyer_connector.find(p=> p.odvjetnik.uid == this.$store.state.logged_in_user.uid && !p.is_outside_member))
    },
    is_permission_inside(wanted_permission, assistent_check = true) {
      if(this.$store.state.logged_in_user.user_role.id == 1)
      {
        return true;
      }else
      return (this.mapped_permission.includes(wanted_permission))
    },
    openPopup(event) {
      if (this.tab_name == 'rocista') {
        this.$store.state.rocista_tab_active = true;
      }
      this.$store.state.event_details.popup_open = true;
      this.$store.state.event_details.chosen_event = event;
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    getDate(date) {
      return date != null ? moment(date).format("DD.MM.yyyy.") : this.$t("components.calendar.event_card.undefined");
    },
    get_avatar(odvjetnik) {
      // Return cached avatar style or null (will show initials fallback)
      if (odvjetnik && this.avatarStyles[odvjetnik.uid]) {
        return this.avatarStyles[odvjetnik.uid];
      }
      return null;
    },
    goToCase(caseId) {
      this.$router.push('/case/' + caseId);
    },
    goToProject(projectId) {
      this.$router.push('/projects/' + projectId);
    }
  },
  mounted() {
    // $(".event-participants").hover(
    //   function () {
    //       gsap.to($(this).find('.case-team-member-img'),0.3,{marginLeft:'-0.8rem',ease: Sine.easeOut}) 
    //   }, 
    //   function () {
    //       gsap.to($(this).find('.case-team-member-img'),0.3,{marginLeft:'-2rem', ease: Sine.easeOut})
    //       gsap.to($(this).find('.case-team-member-img:first-child'),0.3,{marginLeft:'-0.5rem', ease: Sine.easeOut})
    //   }
    // );
    $(".events-tab-view").hover(
      function () {
        gsap.to($(this).find('.event-opis-text'), 0, { display: 'block' })
        gsap.fromTo($(this).find('.event-opis-text'), 0.35, { opacity: 0, y: 10 }, { opacity: 1, y: 0, delay: 0.15 })
        gsap.to($(this).find('.sudionici-eventa'), 0, { display: 'block' })
        gsap.fromTo($(this).find('.sudionici-eventa'), 0.35, { opacity: 0, y: 10 }, { opacity: 1, y: 0, delay: 0.2 })
        gsap.to($(this).find('.case-kalendar-event'), 0.35, { height: '20rem' })
      },
      function () {
        gsap.fromTo($(this).find('.event-opis-text'), 0.2, { opacity: 1, y: 10 }, { opacity: 0, y: 0 })
        gsap.to($(this).find('.event-opis-text'), 0, { display: 'none' })
        gsap.fromTo($(this).find('.sudionici-eventa'), 0.2, { opacity: 1, y: 10 }, { opacity: 0, y: 0 })
        gsap.to($(this).find('.sudionici-eventa'), 0, { opacity: 0, display: 'none', delay: 0.2 })
        gsap.to($(this).find('.case-kalendar-event'), 0.3, { height: '14rem', delay: 0.2 })
      }
    )
  },
  destroyed() {
    $(".events-tab-view").off();
  },
};
</script>